import { render } from "./AppNavigation.vue?vue&type=template&id=4320df72&scoped=true"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"

import "./AppNavigation.vue?vue&type=style&index=0&id=4320df72&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4320df72"]])

export default __exports__